<script setup lang="ts">
import { LucideCircleHelp, LucideClock } from 'lucide-vue-next'
import { ContentBlock } from '~/components/ui/content-block'
import type { IQuiz } from './types'

// Cover, title and description stay on every quiz screen; styled like the organization page header
const props = defineProps<{
  quiz: IQuiz
}>()

const hasMeta = computed(() => !!props.quiz.total_questions_count || !!props.quiz.time_limit)
</script>

<template>
  <ContentBlock variant="white">
    <article class="space-y-5">
      <NuxtImg
        v-if="quiz.image_url"
        :src="quiz.image_url"
        width="1920"
        height="500"
        :alt="quiz.title"
        class="aspect-[1920/500] w-full rounded-md object-cover"
        format="avif,webp"
        fetchpriority="high"
      />
      <div class="space-y-2">
        <Heading tag="h1" class="font-serif text-xl !leading-8 sm:!text-2xl md:!text-3xl">{{ quiz.title }}</Heading>
        <p v-if="quiz.description" class="leading-6 text-gray-600">{{ quiz.description }}</p>
      </div>
      <div v-if="hasMeta" class="flex flex-wrap gap-x-6 gap-y-2 border-t pt-5 text-sm text-gray-700">
        <span v-if="quiz.total_questions_count" class="flex items-center gap-2">
          <LucideCircleHelp class="size-4 text-blue-500" />
          {{ $t('widget.quiz.start.questions_count', quiz.total_questions_count) }}
        </span>
        <span v-if="quiz.time_limit" class="flex items-center gap-2">
          <LucideClock class="size-4 text-orange-500" />
          {{ $t('page.quiz.time_limit', quiz.time_limit) }}
        </span>
      </div>
    </article>
  </ContentBlock>
</template>
